
import { mapState, mapActions, mapMutations } from "vuex";
import emptyAddressImage from "~/assets/images/emptyAddressImage.svg";

export default {
  props: {
    isFullscreen: {
      type: Boolean,
      default: false
    },
    persistent: {
      type: Boolean,
      default: false
    }
  },
  beforeMount() {
    this.getDeliveryAddresses();
  },
  data() {
    return {
      addressLoading: false,
      emptyAddressImage
    };
  },
  computed: {
    ...mapState("order", ["addresses", "cart"])
  },
  methods: {
    ...mapActions("order", [
      "getAddresses",
      "updateCart",
      "getNearestRestaurant",
      "deleteAddress"
    ]),
    ...mapMutations("order", ["SET_INFO_LOADING"]),
    isAlreadySelected(address) {
      return this.cart.delivery_address?.id === address.id;
    },
    async handleAddressDelete(address) {
      try {
        await this.deleteAddress(address.id);
      } catch (error) {
        this.$nuxt.$emit("show-error-toast", error);
      }
    },
    async getDeliveryAddresses() {
      this.addressLoading = true;
      await this.getAddresses();
      this.addressLoading = false;
    },
    async handleLocationSelection(address) {
      if (this.isAlreadySelected(address)) {
        this.$router.push(`/order/menu`);
        return;
      }
      if (!address.house_number) {
        this.$router.push(`/order/address/${address.id}`);
        return;
      }
      try {
        this.SET_INFO_LOADING(true);
        await this.getNearestRestaurant(address);
        await this.updateCart({ address });
        this.$router.push(`/order/menu`);
      } catch (error) {
        this.$nuxt.$emit("show-error-toast", error);
      }
      this.SET_INFO_LOADING(false);
    }
  }
};
